/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Translation } from '../../models/translation';

export interface TranslationsControllerFindOne$Params {

/**
 * The translation id
 */
  id: string;
}

export function translationsControllerFindOne(http: HttpClient, rootUrl: string, params: TranslationsControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<Translation>> {
  const rb = new RequestBuilder(rootUrl, translationsControllerFindOne.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Translation>;
    })
  );
}

translationsControllerFindOne.PATH = '/translations/{id}';
